import bindAllMethods from '../../../utils/bindAllMethods';
import { IMonitoringService } from '../../../services/monitoringService';
import { MonitoringInterfaceV1Type } from './types';
import { getServices } from '../../../infra/startup';

class MonitoringInterfaceV1 {
  private _monitoringService: IMonitoringService;

  constructor() {
    const services = getServices();
    this._monitoringService = services.monitoringService;
    bindAllMethods(this);
  }

  public getInterface(): MonitoringInterfaceV1Type {
    return {
      getSessionId: () => this._monitoringService.getSessionId(),
      startSpan: (name, props) => this._monitoringService.startSpan(name, props)
    };
  }
}

export default MonitoringInterfaceV1;
